import BaseScene from './bases/BaseScene'
import { registePixiPointers } from '../../../utils/event'
import { TimelineLite, Bounce, Power2 } from "gsap/all";
import { Text, TextStyle, Graphics } from 'pixi.js'
import { RES_TYPE, getRootPath, getDataPath, SECOND_FLOOR_INDEX } from '../config'
import { chain } from 'lodash'



const EVENT_NAME = {
    GO: Symbol('GO'),
}

export default class MainScene extends BaseScene {
    constructor(itemList) {
        super(itemList)

        this.pointerAnimGroup = 0
        this.lastActionData = new Date();
        this.isTwitterShowing = false;
        
        this.initItems()
    }

    initItems() {
        this.pointerObjects = []
        this.POINTER_SCALE_RATE = 1.4
        this.DURATION = 0.2

        this.initCharacter()
        
        for(const itemName in this.items) {
            if (this.items[itemName].name.startsWith(RES_TYPE.ITEM_ARTWORK) || this.items[itemName].name.startsWith(RES_TYPE.ITEM_SECTION)) {
                this.initItem(itemName)
            }else if (this.items[itemName].name.startsWith(RES_TYPE.ITEM_WORKSPACE)) {
                this.initWorkstation(itemName)
            }
        }

        registePixiPointers(this.pointerObjects)

        this.initPointerAnim()
    }

    initPointerAnim() {
        this.intervalPointer = setInterval(() => {
            if (this.isActionTimeout()) {
                this.resetActionDate();
                // console.log('ssss')
                // doAnim();
                this.pointerAnimGroup = this.pointerAnimGroup === 8 ? 1 :this.pointerAnimGroup + 1

                const playDuration = 0.5
                const delayRate = playDuration / this.pointerObjects.filter(v => v.ActionGroup === this.pointerAnimGroup).length
                chain(this.pointerObjects).filter(v => v.ActionGroup === this.pointerAnimGroup).sortBy(v => v.x).map((obj, k) => {
                    // console.log(k)
                    // console.log(obj.x)

                    new TimelineLite()
                        .to(obj.scale, 0.5, { 
                            ease: Bounce.easeOut,
                            x: obj.config.scale[0] * 1.6, 
                            y: obj.config.scale[1] * 1.6, 
                            delay: `${delayRate * k}`
                        })
                        .to(obj.scale, 0.5, {
                            ease: Bounce.easeOut,
                            x: obj.config.scale[0], 
                            y: obj.config.scale[1], 
                            delay: '0'
                        });
                    const yRaw = chain(obj.y).cloneDeep().value()
                    new TimelineLite()
                        .to(obj, 0.5, {
                            ease: Power2.easeOut,
                            y: yRaw - 20,
                            delay: `${delayRate * k}`
                        })
                        .to(obj, 0.5, {
                            ease: Power2.easeOut,
                            y: yRaw,
                            delay: '0'
                        });
                }).value()
            }
        }, 1000)
    }

    resetActionDate() {
        this.lastActionData = new Date()
    }

    disableActionDate() {
        this.lastActionData = 0
    }

    isActionTimeout() {
        if (this.lastActionData === 0) {
            return false
        }
        return new Date() - this.lastActionData > 4 * 1000
    }

    initCharacter() {
        // CHARACTER_SUZUME
        this.items[RES_TYPE.CHARACTER_SUZUME].state.setAnimation(0, 'animation', true);
        this.items[RES_TYPE.CHARACTER_SUZUME].state.timeScale = 1;

        // CHARACTER_CONTAINER
        const { pathData } = getDataPath()
        const posStart = pathData[0][0]
        this.items[RES_TYPE.CHARACTER_CONTAINER].x = posStart[0]
        this.items[RES_TYPE.CHARACTER_CONTAINER].y = posStart[1]

        // CHARACTER_FRONT
        this.items[RES_TYPE.CHARACTER_FRONT_R].visible = false
        this.items[RES_TYPE.CHARACTER_FRONT_L].state.setAnimation(0, 'idol_motion', true);
        this.items[RES_TYPE.CHARACTER_FRONT_R].state.timeScale = 1;
        this.items[RES_TYPE.CHARACTER_FRONT_L].state.timeScale = 1;
        
        // CHARACTER_BACK
        this.items[RES_TYPE.CHARACTER_BACK_R].visible = false
        this.items[RES_TYPE.CHARACTER_BACK_L].visible = false
        this.items[RES_TYPE.CHARACTER_BACK_R].state.timeScale = 1;
        this.items[RES_TYPE.CHARACTER_BACK_L].state.timeScale = 1;
        this.items[RES_TYPE.CHARACTER_BACK_R].state.setAnimation(0, 'walk_motion2', true);
        this.items[RES_TYPE.CHARACTER_BACK_L].state.setAnimation(0, 'walk_motion2', true);

        const uiTalk = this.createSpriteByName(RES_TYPE.UI_TALK);
        uiTalk.visible = false
        uiTalk.anchor.x = 0.5
        uiTalk.anchor.y = 1
        uiTalk.x = -10
        uiTalk.y = -180
        let style = new TextStyle({
            // fontFamily: "heisei-kaku-gothic-std",
            fontSize: '24px',
            fontWeight: 'bold'
        });
        const uiTalkText = new Text("アバターテキスト", style);
        uiTalkText.anchor.x = 0.5
        uiTalkText.anchor.y = 0.5
        uiTalkText.y = -48
        uiTalk.addChild(uiTalkText);
        this.items[RES_TYPE.CHARACTER_CONTAINER].addChild(uiTalk)
        this.uiTalk = uiTalk
        this.uiTalkText = uiTalkText

        // Event
        this.graph = new Graphics();
        this.graph.interactive = true;
        this.graph.zIndex = 9999999
        this.graph.visible = false;
        this.graph.alpha = 0
        this.graph.beginFill(0x000000); // black color
        this.graph.drawPolygon([
            0, 0,
            30, 0,
            80, -180,
            270, -180,
            270, -520,
            -270, -520,
            -270, -180,
            -80, -180,
            -30, 0,
            0, 0
        ]);
        this.graph.endFill();
        this.cursorRect = this.createSpriteByName(RES_TYPE.UI_CURSOR_RECT);
        this.items[RES_TYPE.CHARACTER_CONTAINER].addChild(this.cursorRect);
        this.items[RES_TYPE.CHARACTER_CONTAINER].addChild(this.graph);
        this.cursorRect.interactive = true;
        this.cursorRect.anchor.x = 0.5
        this.cursorRect.anchor.y = 0.5
        this.cursorRect.x = 6
        this.cursorRect.y = -73

        this.items[RES_TYPE.CHARACTER_CONTAINER].isBusy = true
        this.intervalBusy = setTimeout(() => {
            this.items[RES_TYPE.CHARACTER_CONTAINER].isBusy = false
        }, 6000)

        this.startMonsterCircle()

        // console.log(APP)
    }

    initItem(itemName) {
        this.setItemOnClick(itemName, this.items[itemName].config.onClick)

        const tagObj = this.addUIPointer(itemName, RES_TYPE.UI_TAG)
        this.setItemMouseOverOut(
            itemName, 
            tagObj, 
            () => this.showAnimationScaleUp(tagObj), 
            () => this.showAnimationScaleDown(tagObj))
    }

    initWorkstation(itemName) {
        this.items[itemName].anchor.x = 0.5
        this.items[itemName].anchor.y = 0.5

        this.setItemOnClick(itemName, this.items[itemName].config.onClick)
        
        const checkObj = this.addUIPointer(itemName, RES_TYPE.UI_CHECK)
        this.setItemMouseOverOut(
            itemName, 
            checkObj, 
            () => {
                if (this._uiTalkTwitterAnimFlag) {
                    return;
                }
                this.showAnimationScaleUp(checkObj)
                this.showNPCTalk(this.items[itemName].config.comment)
            }, 
            () => {
                if (this._uiTalkTwitterAnimFlag) {
                    return;
                }
                this.showAnimationScaleDown(checkObj)
                this.uiTalk.visible = false
            })
    }

    fadeIn(alpha = 0) {
        this.items[RES_TYPE.CHARACTER_CONTAINER].alpha = alpha
        if (alpha >= 1) return
        this.intervalFadeIn = setTimeout(() => {
            this.fadeIn(alpha + 0.1)
        }, 40)
    }

    fadeOut(alpha = 1) {
        this.items[RES_TYPE.CHARACTER_CONTAINER].alpha = alpha
        if (alpha <= 0) return
        this.intervalFadeOut = setTimeout(() => {
            this.fadeOut(alpha - 0.1)
        }, 40)
    }

    startMonsterCircle() {
        this.pathIndex = 0
        this.emitter.on(EVENT_NAME.GO, () => {
            const { rootPath, index } = getRootPath(this.pathIndex)
            this.pathIndex = index
            const tl = new TimelineLite();
            rootPath.forEach((pos, i) => {
                if (i === 0) {
                    return
                }
                const dx = pos[0] - rootPath[i - 1][0]
                const dy = pos[1] - rootPath[i - 1][1]
                let duration = 0

                if (rootPath[i - 1][3] === '#') {
                    duration = 0
                } else if (rootPath[i - 1][3] === '@') {
                    duration = 4
                } else if (rootPath[i - 1][3] === '$') {
                    duration = 0.5
                } else {
                    duration = Math.sqrt((Math.abs(dx * dx) + Math.abs(dy * dy))) / 46
                }

                const zIndex = rootPath[i - 1][2] === 1 ? SECOND_FLOOR_INDEX + 1 : 0

                const fade = rootPath[i - 1][3] === '$' ? 'fadeIn' : rootPath[i - 1][3] === '@' ? 'fadeOut' : null

                this.items[RES_TYPE.CHARACTER_FRONT_R].state.setAnimation(0, 'walk_motion', true);
                this.items[RES_TYPE.CHARACTER_FRONT_L].state.setAnimation(0, 'walk_motion', true);
                this.items[RES_TYPE.CHARACTER_BACK_R].state.setAnimation(0, 'walk_motion2', true);
                this.items[RES_TYPE.CHARACTER_BACK_L].state.setAnimation(0, 'walk_motion2', true);
                this.items[RES_TYPE.CHARACTER_CONTAINER].tl = tl;
                tl.to(
                    this.items[RES_TYPE.CHARACTER_CONTAINER],
                    duration,
                    {
                        x: rootPath[i][0],
                        y: rootPath[i][1],
                        ease: "none",
                        onStart: (dx, dy, zIndex, fade) => {
                            // 前後左右の制御
                            this.items[RES_TYPE.CHARACTER_FRONT_R].visible = false
                            this.items[RES_TYPE.CHARACTER_FRONT_L].visible = false
                            this.items[RES_TYPE.CHARACTER_BACK_R].visible = false
                            this.items[RES_TYPE.CHARACTER_BACK_L].visible = false
                            if (dy < 0 && dx < 0) {
                                if (fade === 'fadeOut') this.items[RES_TYPE.CHARACTER_BACK_L].state.setAnimation(0, 'idol_motion', true);
                                this.items[RES_TYPE.CHARACTER_BACK_L].visible = true
                            } else if (dy < 0 && dx > 0) {
                                if (fade === 'fadeOut') this.items[RES_TYPE.CHARACTER_BACK_L].state.setAnimation(0, 'idol_motion', true);
                                this.items[RES_TYPE.CHARACTER_BACK_R].visible = true
                            } else if (dy > 0 && dx < 0) {
                                if (fade === 'fadeOut') this.items[RES_TYPE.CHARACTER_FRONT_L].state.setAnimation(0, 'idol_motion', true);
                                this.items[RES_TYPE.CHARACTER_FRONT_L].visible = true
                            } else {
                                if (fade === 'fadeOut') this.items[RES_TYPE.CHARACTER_FRONT_R].state.setAnimation(0, 'idol_motion', true);
                                this.items[RES_TYPE.CHARACTER_FRONT_R].visible = true
                            }

                            // z座標の制御
                            this.items[RES_TYPE.CHARACTER_CONTAINER].zIndex = zIndex

                            // 透明度の制御
                            if (fade === 'fadeIn') {
                                this.fadeIn()
                            } else if (fade === 'fadeOut') {
                                setTimeout(() => {
                                    this.fadeOut()
                                }, 3000)
                            }
                        },
                        onStartParams: [dx, dy, zIndex, fade],
                        onComplete: () => {
                            if (i === rootPath.length - 1) {
                                if (this.items[RES_TYPE.CHARACTER_BACK_L].visible) {
                                    this.items[RES_TYPE.CHARACTER_BACK_L].state.setAnimation(0, 'idol_motion', true);
                                } else if (this.items[RES_TYPE.CHARACTER_BACK_R].visible) {
                                    this.items[RES_TYPE.CHARACTER_BACK_R].state.setAnimation(0, 'idol_motion', true);
                                } else if (this.items[RES_TYPE.CHARACTER_FRONT_L].visible) {
                                    this.items[RES_TYPE.CHARACTER_FRONT_L].state.setAnimation(0, 'idol_motion', true);
                                } else if (this.items[RES_TYPE.CHARACTER_FRONT_R].visible) {
                                    this.items[RES_TYPE.CHARACTER_FRONT_R].state.setAnimation(0, 'idol_motion', true);
                                }
                                this.intervalBusy = setTimeout(() => {
                                    this.items[RES_TYPE.CHARACTER_CONTAINER].isBusy = false
                                }, 6000)
                            }
                        },
                    },
                );
            })
        })

        this.intervalMonster = setInterval(() => {
            if (!this.items[RES_TYPE.CHARACTER_CONTAINER].isBusy) {
                this.items[RES_TYPE.CHARACTER_CONTAINER].isBusy = true
                this.emitter.emit(EVENT_NAME.GO);
            }
        }, 100)
    }

    addUIPointer(itemName, pointerName) {
        const obj = this.createSpriteByName(pointerName)
        obj.ActionGroup = this.items[itemName].config.data.ActionGroup

        obj.anchor.x = 0.5
        obj.anchor.y = 1
        obj.x = this.items[itemName].config.data.PointX
        obj.y = this.items[itemName].config.data.PointY
        if (itemName === 'item:artwork_kakejiku' || itemName === 'item:artwork_chest') {
            obj.zIndex = 99999
        } else {
            obj.zIndex = this.items[itemName].zIndex
        }
        obj.visible = false
        this.items[itemName].parent.addChild(obj)
        this.pointerObjects.push(obj)
        return obj
    }

    showAnimationScaleUp(obj) {
        new TimelineLite().to(obj.scale, this.DURATION, { x: obj.config.scale[0] * this.POINTER_SCALE_RATE, y: obj.config.scale[1] * this.POINTER_SCALE_RATE, delay: '0'});
    }

    showAnimationScaleDown(obj) {
        new TimelineLite().to(obj.scale, this.DURATION, { x: obj.config.scale[0], y: obj.config.scale[1], delay: '0'});
    }

    setItemMouseOverOut(itemName, pointerObj, funcOver, funcOut) {
        this.items[itemName].interactive = true;
        this.items[itemName].on('mouseover', () => {
            // console.log('mouseover')
            if (this.isTwitterShowing) {
                return;
            }
            this.disableActionDate()

            document.body.style.cursor = 'pointer'

            if (pointerObj.visible === false) {
                pointerObj._invisibleMode = true
                pointerObj.visible = true
            } else {
                pointerObj._invisibleMode = false
            }
            funcOver()
        });
        this.items[itemName].on('mouseout', () => {
            // console.log('mouseout')
            this.resetActionDate()

            document.body.style.cursor = 'default'

            if (pointerObj._invisibleMode === true) {
                pointerObj.visible = false
            }
            funcOut()
        });
    }

    showNPCTalk(text) {
        this.uiTalkText.text = text

        this.uiTalk.scale.x = this.uiTalk.config.scale[0] / 10
        this.uiTalk.scale.y = this.uiTalk.config.scale[1] / 10
        if (!this.__blockOtherCursor) {
            this.uiTalk.visible = true
        }
        this.showAnimationScaleUp(this.uiTalk)
    }


    destroy() {
        if (this.intervalMonster) {
            clearInterval(this.intervalMonster)
        }
        if (this.intervalPointer) {
            clearInterval(this.intervalPointer)
        }
        if (this.timerTwitter) {
            clearInterval(this.timerTwitter)
        }
        if (this.intervalBusy) {
            clearInterval(this.intervalBusy)
        }
        if (this.intervalFadeIn) {
            clearInterval(this.intervalFadeIn)
        }
        if (this.intervalFadeOut) {
            clearInterval(this.intervalFadeOut)
        }
    }
}